export default "__VITE_PUBLIC_ASSET__5e6927f8__"